<style>
@import '../../assets/css/calculator.css';
</style>

<template>
    <b-row class="text-center mt-5">
        <b-col cols="12">
            <div class="container">
                <language id="language-select" class="language" ref="lang"/>
                <br/>
                <b-col cols="12" class="p-0">
                    <div class="mx-auto">
                        <img src='@/assets/img/calculator/logo.png' class="img-fluid cal-logo">
                    </div>
                </b-col>
            </div>
            
            <br>
            <img src='@/assets/img/calculator/top_bg.jpg' class="img-fluid" style="max-height:450px;">
            <b-col cols="12" class="top-title">
                {{$t('mix.table_your_potential_income')}}
            </b-col>
            
            <div class="container text-left" style="max-width: 941px;background: #fff;">
                <b-row>
                    <b-col cols="12">
                        <b-row>
                            <b-col cols="8" style="margin: 30px auto;">
                                <div v-if="!calculateLayout">
                                    <p class="calculator-title">{{$t('mix.table_online_shopping')}}</p>

                                    <p class="calculator-content">{{$t('mix.table_allocated_member')}}</p>
                                    <b-form-input v-model="postForm.downline" :placeholder="$t('mix.table_allocated_member')"></b-form-input>
                                    
                                    <p class="calculator-content">{{$t('mix.table_average_member_monthly')}}</p>
                                    <b-form-input v-model="postForm.sales" :placeholder="$t('mix.table_average_member_monthly')"></b-form-input>

                                    <p class="calculator-content">{{$t('mix.table_monthly_new_member')}}</p>
                                    <b-form-input v-model="postForm.new_register" :placeholder="$t('mix.table_monthly_new_member')"></b-form-input>
                                    
                                    <p class="calculator-content">{{$t('mix.table_accumulated_member')}}</p>
                                    <b-form-input v-model="postForm.accumulated_register" :placeholder="$t('mix.table_accumulated_member')"></b-form-input>

                                    <p class="calculator-content">{{$t('mix.table_rank_level')}}</p>
                                    <el-select v-model="postForm.rank_id" class="w-100 mb-3" :placeholder="$t('mix.table_rank_level')" filterable>
                                        <el-option v-for="(list,index) in rankList" :key="index" :label="list.name" :value="list.id"></el-option>
                                    </el-select>

                                    <p class="calculator-title mt-5">{{$t('mix.table_estore')}}</p>

                                    <p class="calculator-content">{{$t('mix.table_estore_purchase')}}</p>
                                    <b-form-input v-model="postForm.e_store_purchase" :placeholder="$t('mix.table_estore_purchase')"></b-form-input>
                                    
                                    <p class="calculator-content">{{$t('mix.table_estore_accumulated')}}</p>
                                    <b-form-input v-model="postForm.e_store_downline" :placeholder="$t('mix.table_estore_accumulated')"></b-form-input>

                                    <p class="calculator-content">{{$t('mix.table_estore_introduced')}}</p>
                                    <b-form-input v-model="postForm.e_store_downline_sales" :placeholder="$t('mix.table_estore_introduced')"></b-form-input>

                                    <el-button class="mt-5 w-100 submit-button" @click.native="submit()"><span class="h6">{{$t('mix.table_calculate')}}</span></el-button>
                                </div>

                                <div v-else>
                                    <p class="calculator-title">{{$t('mix.table_online_shopping')}}</p>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_commission.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    RM {{calculatorResult.onlineShopping.bonus_commission}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_introducer.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    RM {{calculatorResult.onlineShopping.immediate_income}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_mbonus.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    {{calculatorResult.onlineShopping.m_bonus}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_score_point.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    {{calculatorResult.onlineShopping.score_point}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <p class="calculator-title mt-4">{{$t('mix.table_estore')}}</p>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_commission.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    RM {{calculatorResult.eStore.bonus_commission}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_introducer.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    RM {{calculatorResult.eStore.immediate_income}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_mbonus.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    {{calculatorResult.eStore.m_bonus}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col cols="4 pr-0">
                                            <img src="@/assets/img/common/icon_score_point.png" class="calculator-result-img">
                                        </b-col>
                                        <b-col cols="8 pl-0">
                                            <div class="calculator-result-content">
                                                <p>
                                                    <span class="mr-2" style="color:#bfbfbf">{{$t('mix.table_estimate')}}</span>
                                                    {{calculatorResult.eStore.score_point}}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <el-button class="mt-5 w-100 submit-button" @click="calculateLayout = false"><span class="h6">{{$t('mix.table_recalculate')}}</span></el-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>

            <b-col cols="12" class="bottom-title">
                {{$t('mix.table_make_your_extra_income')}}
            </b-col>

            <b-row class="mx-auto mt-4" style="max-width: 941px;">
                <b-col cols="8" class="text-right">
                    <img src='@/assets/img/calculator/logo.png' class="img-fluid bottom-logo">
                </b-col>
                <b-col cols="4" class="text-left">
                    <img src='@/assets/img/calculator/qr_code.png' class="img-fluid bottom-qr">
                </b-col>
            </b-row>

            <div class="my-5">
                <a :href="calculateData.registerHref" target="_blank">
                    <img src="@/assets/img/calculator/icon_register.png" class="img-fluid bottom-pic" style="border-right: 2px solid #fff;">
                </a>

                <a :href="calculateData.shoppingHref" target="_blank">
                    <img src="@/assets/img/calculator/shopping_icon.png" class="img-fluid bottom-pic" style="border-right: 2px solid #fff;">
                </a>
                    
                <a :href="calculateData.eStoreHref" target="_blank">
                    <img src="@/assets/img/calculator/my_shop_icon.png" class="img-fluid bottom-pic">
                </a>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import language from '@/components/language';

export default {
    components:{language},
    data(){
        return{
            buttonloading: true,
			postData: {
				data: '',
				language: '',
			},
			submitForm: {
				id:'',
            },
            postForm:{
                downline:'',
                sales:'',
                new_register:'',
                accumulated_register:'',
                rank_id:'',
                e_store_purchase:'',
                e_store_downline:'',
                e_store_downline_sales:''
            },
            calculatorResult:{
                onlineShopping:[],
                eStore:[]
            },
            calculateLayout:false,
            rankList:'',
            calculateData:{
                registerHref:'',
                shoppingHref:'',
                eStoreHref:'',
            }
        }
    },
    methods:{
        initial(){
			this.buttonloading = true;
			this.postData.data = this.$method.getEAES(JSON.stringify(this.submitForm));
			var result = this.$method.postMethod('common/calculator',this.postData);
			result.then((value) => {
				var data = JSON.parse(this.$method.getDAES(value.data));
				if(value.valid){
                    this.rankList = data.rankList;
                    this.postForm.rank_id = data.rankList[0].id;
                    this.calculateData = data;
                    localStorage.setItem('languageList', JSON.stringify(data.languageList));
                }
				this.buttonloading = false;
			})
        },
        submit(){
            this.buttonloading = true;
            this.postData.data = this.$method.getEAES(JSON.stringify(this.postForm));
            var result = this.$method.postMethod('common/calculator/calculate',this.postData);
            result.then((value) => {
                var data = JSON.parse(this.$method.getDAES(value.data));
                if(value.valid){
                    this.calculatorResult = data;
                    this.calculateLayout = true;
                }else{
                    this.$method.popupErrorMessage(data.returnMsg,this);
                }
                this.buttonloading = false;
            })
        },
    },
    created(){
		this.postData.language = this.$localStorage.getItem('currentLang') ?? 'cn';
        this.initial();
    }
}
</script>